<template>
    <div>
      <b-row class="mt-5">
        <b-col cols="4">
         <b-form-group label="Hub : "  :label-cols="2" >
           <b-form-select class="form-control input" v-model="destinationhubid" @change="getCurrentStatusCODListing(1)">
             <option :value="null"  >--Select--</option>
                <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
            </b-form-select>          
          </b-form-group> 
        </b-col>
      </b-row>

      <b-row class="my-2"> 
        <b-col sm="12" class="text-right">
          <b-col sm="12">  
            <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
          </b-col>
        </b-col> 

        <b-col sm="12">
          <b-table 
            show-empty 
            stacked="md"
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :bordered="bordered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div> 

            <template slot="total_cod_amount_in_hub" slot-scope="row">
              <p style="text-align: center;">{{row.item.total_cod_amount_in_hub}}</p>                    
            </template> 
          </b-table>
        </b-col>     
      </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
  export default{
    data:function(){
      return{
        name:'currentStatusCOD',
        isBusy: false,
        items: [],
        fields: [
          {key:'hub_name',label:'Hub Name'},
          {key:'total_cod_amount_in_hub',label:'Current Amount HUB'},    
        ],

        bordered: true,
        totalRows: 0,

        destinationhubid:null,
        hublist:[],

      }
    },

    created:function(){
      this.getHublist();
      this.getCurrentStatusCODListing(1);
    },

    methods:{
      getHublist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
          }
        })
        .catch(ex => {
          console.log('error', ex)
        });
      },

      getCurrentStatusCODListing:function(pageNo){
        this.isBusy = true;

          const Obj ={
            hub_id: this.destinationhubid ? `${this.destinationhubid}`:"",
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTotalCODPendingAmountInHub`,Obj)
          .then(result=>{
            this.isBusy = false;
            if(result.body && result.body.returnmsg === 'Successful'){
              this.items = result.body.returnvalue;
              this.totalRows = result.body.returnvalue.length;
            }
            else{
              this.items = [];
              this.totalRows = 0;
            }
          })
          .catch(ex =>{
            console.log('error',ex)
          })
      },
    }
  }
</script>